// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractMoveController = function ($scope, $routeParams, $location, $http, Customer, Contract) {
    $scope.contractId = $routeParams.contractId;
    $scope.moving = false;
    $scope.contract = Contract.get({ contractId: $routeParams.contractId });

    function parseUrl(s) {
        var regex = /(\/customers\/)?([0-9a-fA-F]{24})/;
        var result = regex.exec(s);
        if (result)
            return result[2];
        return null;
    }

    $scope.search = function () {
        var input = parseUrl($scope.input) || $scope.input;
        $scope.customers = Customer.query({ search: input, take: 10 });
        $scope.newCustomer = null;
    };

    $scope.move = function () {
        if ($scope.moving)
            return;
        $scope.moving = true;
        $http({
            method: "POST", url: "/api/v1/contracts/" + $routeParams.contractId + "/move", params: null,
            data: { CustomerId: $scope.newCustomer.Id }, headers: {}, cache: false
        }).then(function () {
            $location.path("/contracts/" + $routeParams.contractId);
        }, function() {
            $scope.moving = false;
        });
    };
};
ContractMoveController.$inject = ['$scope', '$routeParams', '$location', '$http', 'Customer', 'Contract'];
